import styled from 'styled-components';

export const TenantsCardBlock = styled.div`
  background-color: #f7f7f7;
  padding: 50px 0;
  margin: 50px 0px 0px;
`;

export const TenantsDetails = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
  min-height: 433px;
  overflow: hidden;
  justify-content: center;
`;

export const TenantsDetailsPart = styled.div`
  background: #ebebeb;
  transition: 0.5s;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 50px 30px 30px;

  p {
    margin-bottom: 1.5rem;

    &[dir='ltr'] {
      letter-spacing: 1.29px;
    }
  }
`;

export const Titleh3 = styled.h3`
  text-transform: uppercase;
  margin-bottom: 1.5rem;

  @media (max-width: 1200px) {
    font-size: 18px;
  }

  @media (max-width: 767.98px) {
    font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
  }
`;
export const TenantsContainer = styled.div`
  @media (min-width: 576px) {
    max-width: 540px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 1200px) {
    max-width: 1220px;
  }

  @media (max-width: 575.98px) {
    padding: 0 30px;
  }
  @media (max-width: 350px) {
    padding-right: 15px;
    padding-left: 15px;
  }
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;
